require("./toaster.js");
module.exports = "toaster";



//////////////////
// WEBPACK FOOTER
// ./~/angularjs-toaster/index.js
// module id = 616
// module chunks = 1